module.exports = __webpack_public_path__ + "img/circle_icon.5438f60a.svg";